const DEVICE_TYPE = { MOBILE: 'mobile', DESKTOP: 'desktop', TAB: 'tab' };
export default DEVICE_TYPE;
